const baseDomain = process.env.VUE_APP_POSTING_DOMAIN; //"posting-api-test.adx-co.jp"; //"ato-auto-estimate.107.jp"
// const orikomiDomain = "newspaper-api.107.jp"
const orikomiDomain = process.env.VUE_APP_ORIKOMI_DOMAIN; //"orikomi-exclusive-test-api.107.jp";
const orikomiDomainStorage = process.env.VUE_APP_ORIKOMI_DOMAIN_STORAGE; //"orikomi-exclusive-test-api.107.jp";
const paymentDomain = process.env.VUE_APP_PAYMENT_DOMAIN; //"ato-payment-test-api.107.jp";
// const clientManagementDomain = 'ato-client-management.107.jp'
const clientManagementDomain = process.env.VUE_APP_CLIENT_MANAGEMENT; //"client-management.adx-co.jp";
const storeUrl = process.env.VUE_APP_STORE_URL;

const mapOrikomiExclusive = process.env.VUE_APP_ORIKOMI_EXCLUSIVE_MAP;
const mapPosting = process.env.VUE_APP_POSTING_MAP;
const storageDomain = process.env.VUE_APP_STORAGE_DOMAIN;
const storageDomainWSS = process.env.VUE_APP_STORAGE_DOMAIN_WSS;
const storageExclusiveWSS = process.env.VUE_APP_STORAGE_EXCLUSIVE_WSS;
const systemName = process.env.VUE_APP_SYSTEM_NAME;

export {
  baseDomain,
  orikomiDomain,
  paymentDomain,
  clientManagementDomain,
  mapOrikomiExclusive,
  mapPosting,
  storeUrl,
  orikomiDomainStorage,
  storageDomain,
  systemName,
  storageDomainWSS,
  storageExclusiveWSS,
};
